export default {"src":"/_next/static/media/gala-lite-node.bea4898a.svg","height":36,"width":37};